import { render } from "./App.vue?vue&type=template&id=2a7223a0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2a7223a0&lang=css"

import exportComponent from "/Users/woniu/Desktop/woniu/web-tuiguangzu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__